import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LIST_STYLE_TYPES, SPACING } from './constants';

const List = ({ children, styleType = LIST_STYLE_TYPES.disc, spacing = SPACING.default }) => {
  const classes = classNames('ws-ui-list', `ws-ui-list--${styleType}`, `ws-ui-list--${spacing}`);
  return <ul className={classes}>{children}</ul>;
};

List.propTypes = {
  children: PropTypes.node.isRequired,
  styleType: PropTypes.oneOf(Object.values(LIST_STYLE_TYPES)),
  spacing: PropTypes.oneOf(Object.values(SPACING)),
};

export default List;
